export default {
    SET_CURRENT_ROUTE(state, route) {
        state.currentRoute = route
        state.navigating_back = false
    },
    SET_LOADING(state, loading) {
        state.loading = loading
    },
    SET_NAVIGATING_BACK(state) {
        state.navigating_back = true
    }
}
